import React, { useEffect, useState } from "react";
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer/index.jsx';
import { Modal, Button } from 'react-bootstrap';
import { api } from '../../services/api.js';
import PontoCard from '../Components/Ponto/PontoCard.jsx';
import { useNavigate } from 'react-router-dom';
import Foto from "../Components/Foto";
import { FaClock, FaStore, FaExclamationTriangle } from 'react-icons/fa';

const fotoCache = new Map();

function LoadingModal({ show, message }) {
    if (!show) return null;
    return (
        <div className="loading-modal-overlay">
            <div className="loading-modal-content">
                <div
                    className="spinner-border text-danger"
                    role="status"
                    style={{ width: '3rem', height: '3rem' }}
                >
                    <span className="visually-hidden">Carregando...</span>
                </div>
                <div style={{ marginTop: 15, fontSize: 16, fontWeight: 600, color: '#2c3e50' }}>{message}</div>
            </div>
            <style>{`
                .loading-modal-overlay {
                    position: fixed;
                    top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0,0,0,0.5);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 1050;
                    backdrop-filter: blur(4px);
                }
                .loading-modal-content {
                    background: white;
                    padding: 25px 40px;
                    border-radius: 16px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    box-shadow: 0 10px 30px rgba(0,0,0,0.2);
                }
            `}</style>
        </div>
    );
}

function AprovacaoPonto() {
    const [registros, setRegistros] = useState([]);
    const [pesquisa, setPesquisa] = useState(0);
    const [loading, setLoading] = useState(false);
    const [erroPermissao, setErroPermissao] = useState(false);
    const [loja, setLoja] = useState(0);
    const [loadingMessage, setLoadingMessage] = useState('');
    const [temPermissao, setTemPermissao] = useState(null);
    const [lojasPermitidas, setLojasPermitidas] = useState([]);
    const [fotoSelecionada, setFotoSelecionada] = useState(null);
    const navigate = useNavigate();

    const permitePonto = localStorage.getItem("permitePonto");

    useEffect(() => {
        if (permitePonto === 'N') {
            setTemPermissao(false);
            setErroPermissao(true);
            return;
        }

        const lojaStorage = localStorage.getItem("loja");
        const lojas = JSON.parse(localStorage.getItem("lojasPermitidas") || "[]");

        if (lojaStorage) {
            setLoja(lojaStorage);
            setPesquisa(lojaStorage);
        }

        setLojasPermitidas(lojas);
        setTemPermissao(permitePonto === "S");
    }, [permitePonto]);

    useEffect(() => {
        if (temPermissao !== true || !loja) return;

        setLoading(true);
        setLoadingMessage('Aguarde... Consultando registros de ocorrência');

        api.get(`/ponto/${pesquisa || loja}/ocorrencia`)
            .then(response => {
                setRegistros(response.data);
                setLoading(false);
            })
            .catch(err => {
                console.error("Erro ao carregar registros de ponto:", err);
                setRegistros([]);
                setLoading(false);
            });
    }, [pesquisa, loja, temPermissao]);

    function handleUpdate(chapa, data) {
        setRegistros(prev =>
            prev.filter(r => !(r.matricula === chapa && r.data === data))
        );
    }

    return (
        <div className="bg-light min-vh-100" style={{ paddingTop: '80px', paddingBottom: '40px' }}>
            <Menu modulo="ARBOR" />
            <LoadingModal show={loading} message={loadingMessage} />

            {/* CONTAINER CENTRALIZADO COM CONTAINER-FLUID MAX-WIDTH */}
            <div 
                className="container-fluid py-3 px-3 px-md-5"
                style={{ maxWidth: '1280px', margin: '0 auto' }}
            >
                {temPermissao ? (
                    <>
                        {/* Título da Tela */}
                        <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-2">
                            <div>
                                <h4 className="fw-bold m-0 d-flex align-items-center text-dark">
                                    <FaClock className="me-2 text-danger" />
                                    Aprovação de Ocorrências de Ponto
                                </h4>
                                <small className="text-muted">Acompanhe e trate os pontos pendentes da equipe</small>
                            </div>

                            {/* Seletor de Loja */}
                            <div className="d-flex align-items-center gap-2 bg-white p-2 rounded-3 border shadow-sm" style={{ minWidth: '260px' }}>
                                <FaStore className="text-danger ms-1" />
                                <select
                                    className="form-select border-0 bg-transparent fw-semibold text-secondary py-1"
                                    value={pesquisa}
                                    onChange={e => setPesquisa(e.target.value)}
                                >
                                    <option value="0">Todas as lojas permitidas</option>
                                    {lojasPermitidas.map(l => (
                                        <option key={l} value={l}>Loja {l}</option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {/* Lista de Registros Centralizada e Preenchendo a Largura */}
                        <div className="row g-3 justify-content-start align-items-stretch">
                            {registros.length > 0 ? (
                                registros.map(registro => (
                                    <div
                                        className="col-12 col-md-6 col-lg-4 d-flex"
                                        key={`${registro.matricula}_${registro.data}`}
                                    >
                                        <div className="w-100">
                                            <PontoCard
                                                registro={registro}
                                                onUpdate={handleUpdate}
                                                onExpandFoto={(urlBase64, nome, info01) => {
                                                    setFotoSelecionada({
                                                        foto: urlBase64,
                                                        nome: nome,
                                                        loja: info01 || ""
                                                    });
                                                }}
                                                fotoCache={fotoCache}
                                            />
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="col-12 text-center py-5">
                                    <div className="bg-white p-5 rounded-4 shadow-sm border mx-auto" style={{ maxWidth: '500px' }}>
                                        <FaClock className="text-muted opacity-50 mb-3" size={48} />
                                        <h5 className="fw-bold text-dark mb-1">Nenhuma ocorrência encontrada</h5>
                                        <p className="text-muted small mb-0">Não há pendências de ponto para a loja selecionada neste momento.</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                ) : null}

                {/* Modal de Permissão Negada */}
                <Modal show={erroPermissao} onHide={() => navigate('/arbor/dadosFunc')} centered className="rounded-4 overflow-hidden">
                    <Modal.Header className="bg-danger text-white border-0">
                        <Modal.Title className="fw-bold fs-5 d-flex align-items-center">
                            <FaExclamationTriangle className="me-2" /> Acesso Negado
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-4 text-center">
                        <p className="text-dark fw-semibold mb-2">Você não possui permissão para acessar o módulo de Aprovação de Ponto.</p>
                        <small className="text-muted d-block">Caso necessite desta funcionalidade, entre em contato com o administrador do sistema.</small>
                    </Modal.Body>
                    <Modal.Footer className="border-0 justify-content-center pt-0">
                        <Button 
                            className="btn-danger-gradient px-4 py-2 fw-bold"
                            style={{
                                background: 'linear-gradient(135deg, #8b0000 0%, #c0392b 100%)',
                                border: 'none',
                                borderRadius: '10px'
                            }}
                            onClick={() => navigate('/arbor/dadosFunc')}
                        >
                            Voltar ao início
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Foto
                    show={!!fotoSelecionada}
                    onClose={() => setFotoSelecionada(null)}
                    foto={fotoSelecionada?.foto}
                    nome={fotoSelecionada?.nome}
                    info01={fotoSelecionada?.loja}
                    info02=""
                />
            </div>

            {!loading && <Footer />}
        </div>
    );
}

export default AprovacaoPonto;